import { PurchaseOrderDetail } from "./purchase-order-detail.entity";

export class PurchaseOrderHeader {
    purchaseOrderHeaderId: number;
    poNumber: string;
    poRaiseDate: string;
    estimatedDeliveryDate: Date | null;
    createdBy: number;
    createdDate: Date;
    tenderStatusId: number;
    totalAmount: number;
    totalTax: number;
    totalNetAmount: number;
    supplierId: number;
    pharmacyWareHouseId: number;
    dueDays: number | null;
    locationId: number | null;
    centralWarehouseLocationId: number | null;
    supplierName: string;
    wareHouseName: string;
    locationName: string;
    createdByName: string;
    status: string;
    billNumber: string;
    billType: string;
    billDate: Date | null;
    dueDate: Date | null;
    billAmount: number | null;
    discount: number | null;
    taxes: number | null;
    netamount: number | null;
    pharmacyPurchaseHeaderId: number | null;

    supplier: any;
    poDetail: Array<PurchaseOrderDetail>;
    totalBillCount?: number;

    constructor() { this.poDetail = new Array<PurchaseOrderDetail>(); }
}